module.exports = __webpack_public_path__ + "img/philcare-logo.0284f48b.png";